/* ==========================================================
   BYOB — Controller (CLEAN / STABLE)
   SOURCE OF TRUTH: window.BYOB_DATA
========================================================== */

(function () {
  function register() {
    if (!window.Alpine) return;
    if (window.__BYOB_CONTROLLER_REGISTERED__) return;

    window.__BYOB_CONTROLLER_REGISTERED__ = true;

    Alpine.data('byobController', () => ({
    /* -----------------------------
       CORE STATE
    ----------------------------- */
    phase: 'entry',

    selectedBangleSize: null,
    selectedBox: null,
    selectedStyles: [],

    sizes: [],
    boxSizes: [],
    sizeGroupsRaw: [],
    availableStyles: [],

    sizeGuideOpen: false,
    isEditing: false,
    hasEdited: false,
    showEditGrid: false,

    isAddingToCart: false,
    cartSuccess: false,
    cartError: null,

    /* -----------------------------
       INIT
    ----------------------------- */
    init() {
      const DATA = window.BYOB_DATA || {};

      this.phase = 'entry';
      this.selectedBangleSize = null;
      this.selectedBox = null;
      this.selectedStyles = [];
      this.sizeGuideOpen = false;
      this.isEditing = false;
      this.hasEdited = false;
      this.isAddingToCart = false;
      this.cartSuccess = false;
      this.cartError = null;

      this.sizes = Array.isArray(DATA.sizes)
        ? DATA.sizes.slice().sort((a, b) => {
            return Number(a.sort_order || 0) - Number(b.sort_order || 0);
          })
        : [];

      this.boxSizes = Array.isArray(DATA.boxSizes)
        ? DATA.boxSizes.slice().sort((a, b) => {
            return Number(a.capacity || 0) - Number(b.capacity || 0);
          })
        : [];

      this.sizeGroupsRaw = Array.isArray(DATA.sizeGroupsRaw)
        ? DATA.sizeGroupsRaw.slice()
        : [];

      this.updateAvailableStyles();

this.$nextTick(() => {
  this.updateAvailableStyles();
});
    },

    /* -----------------------------
       NORMALIZERS
    ----------------------------- */
    normalizeSize(value) {
      return String(value == null ? '' : value).trim();
    },

    /* -----------------------------
       DERIVED
    ----------------------------- */
    get capacity() {
      return this.selectedBox ? this.selectedBox.capacity : 0;
    },

    get layout() {
      const c = Number(this.capacity || 0);
      if (!c) return { cols: 0, rows: 0 };

      if (c === 3) return { cols: 3, rows: 1 };
      if (c === 6) return { cols: 6, rows: 1 };
      if (c === 9) return { cols: 3, rows: 3 };
      if (c === 12) return { cols: 4, rows: 3 };
      if (c === 24) return { cols: 6, rows: 4 };
      if (c === 36) return { cols: 6, rows: 6 };
      if (c === 48) return { cols: 6, rows: 8 };
      if (c === 72) return { cols: 8, rows: 9 };

      const cols = 6;
      return { cols, rows: Math.ceil(c / cols) };
    },

    get boxCapacity() {
  return this.selectedBox ? this.selectedBox.capacity : '';
},

get selectedVariantId() {
  if (!this.selectedBangleSize || !this.selectedBox) return null;

  const size = String(this.selectedBangleSize).trim();
  const capacity = String(this.selectedBox.capacity).trim();

  const key = `${size}|${capacity}`;

  return window.BYOB_DATA?.variantMap?.[key] || null;
},

    get selectedStyleLabels() {
      if (!this.selectedStyles.length) return '';

      return this.selectedStyles
        .map((id) => {
          const match = this.availableStyles.find(
            (style) => String(style.id) === String(id)
          );
          return match ? match.label : null;
        })
        .filter(Boolean)
        .join(', ');
    },

    get remaining() {
      const filled = this.selectedStyles.filter(Boolean).length;
      return Math.max(this.capacity - filled, 0);
    },

    get isComplete() {
      return (
        this.capacity > 0 &&
        this.remaining === 0 &&
        this.isEditing &&
        this.hasEdited
      );
    },

    get slotItems() {
      const items = [];
      const capacity = this.capacity;

      for (let i = 0; i < capacity; i++) {
        const id = this.selectedStyles[i] || null;

        const style =
          id != null
            ? this.availableStyles.find((s) => String(s.id) === String(id)) || null
            : null;

        items.push({ key: i, style });
      }

      return items;
    },

    /* -----------------------------
       DATA ENGINE (FIX)
    ----------------------------- */
    updateAvailableStyles() {
  if (!this.selectedBangleSize) {
    console.log('⚠️ No size selected, skipping filter')
    return
  }

  console.log('Selected size:', this.selectedBangleSize)

      const selectedSize = String(this.selectedBangleSize).trim();

      const groups = this.sizeGroupsRaw
        .filter((g) => {
          return (
            g &&
            g.active === true &&
            String(g.bangle_size).trim() === selectedSize
          );
        })
        .sort((a, b) => Number(a.group_index || 0) - Number(b.group_index || 0));

      const merged = [];

      groups.forEach((group) => {
        const styles = Array.isArray(group.styles) ? group.styles : [];

        styles.forEach((style) => {
          if (
            style &&
            style.active === true &&
            Number(style.inventory_dozens || 0) > 0
          ) {
            merged.push(style);
          }
        });
      });

      this.availableStyles = merged.sort((a, b) => {
        return Number(a.sort_order || 0) - Number(b.sort_order || 0);
      });
    },

    /* -----------------------------
       ENTRY ACTIONS
    ----------------------------- */
    selectBangleSize(size) {
      const normalizedIncoming = this.normalizeSize(size);
      const normalizedCurrent = this.normalizeSize(this.selectedBangleSize);

      if (normalizedCurrent && normalizedCurrent !== normalizedIncoming) {
        this.selectedStyles = [];
      }

      this.selectedBangleSize = normalizedIncoming;
      this.updateAvailableStyles();
      this.tryEnterBuild();
    },

    selectBox(box) {
      this.selectedBox = box;
      this.tryEnterBuild();
    },

    tryEnterBuild() {
      if (this.selectedBangleSize && this.selectedBox) {
        this.phase = 'build';
      } else {
        this.phase = 'entry';
      }
    },

    /* -----------------------------
       BUILD ACTIONS
    ----------------------------- */
    isSelected(id) {
      return this.selectedStyles.includes(id);
    },

    toggleStyle(style) {
      if (!style || !style.id || !this.capacity) return;

      const id = style.id;

      if (this.isSelected(id)) {
        this.selectedStyles = this.selectedStyles.map((x) => (x === id ? null : x));
        this.selectedStyles = this.selectedStyles.slice();
        this.isEditing = true;
        this.hasEdited = true;
        return;
      }

      const filled = this.selectedStyles.filter(Boolean).length;
      if (filled >= this.capacity) return;

      const emptyIndex = this.selectedStyles.findIndex((v) => !v);

      if (emptyIndex >= 0) {
        this.selectedStyles[emptyIndex] = id;
      } else {
        this.selectedStyles.push(id);
      }

      this.selectedStyles = this.selectedStyles.slice();

if (this.remaining === 0) {
  this.showEditGrid = false;
}
    },

    removeStyleAt(index) {
      index = Number(index);
      if (index < 0 || index >= this.selectedStyles.length) return;

      this.selectedStyles[index] = null;
      this.selectedStyles = this.selectedStyles.slice();

      this.isEditing = true;
      this.hasEdited = true;
    },

    addToCart() {
  if (window.__BYOB_ADDING_TO_CART__) return;
  if (this.isAddingToCart) return;

  if (!this.selectedVariantId) {
    console.error('❌ No variant selected — blocking add to cart');
    this.cartError = 'Please complete your box before adding to cart.';
    return;
  }

  window.__BYOB_ADDING_TO_CART__ = true;
  this.isAddingToCart = true;

  this.submitForm();
},

    async submitForm(callback) {
      this.cartSuccess = false;
      this.cartError = null;

      try {
        const form = document.getElementById('byob-product-form');
if (!form) {
  throw new Error('BYOB form not found');
}

const formData = new FormData(form);

        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'application/json'
          }
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Add to cart failed');
        }

        const cartResponse = await fetch('/cart.js', {
  credentials: 'same-origin',
  cache: 'no-store'
});

const cart = await cartResponse.json();

this.cartSuccess = true;

document.dispatchEvent(new CustomEvent('cart:update', {
  bubbles: true,
  detail: {
    resource: cart,
    sourceId: 'byob-controller',
    data: {
      itemCount: cart.item_count,
      source: 'byob-controller',
      variantId: String(this.selectedVariantId)
    }
  }
}));

const cartDrawer = document.querySelector('cart-drawer-component');
if (cartDrawer && typeof cartDrawer.open === 'function') {
  cartDrawer.open();
}

        setTimeout(() => {
  this.resetAll();
}, 1000);

        if (typeof callback === 'function') {
          callback();
        }
      } catch (err) {
        console.error('BYOB add to cart failed:', err);
        this.cartError = 'To Add Another Box. Please click Start Over.';
      } finally {
        this.isAddingToCart = false;
        window.__BYOB_ADDING_TO_CART__ = false;
      }
    },

    resetAll() {
      this.phase = 'entry';
      this.selectedBangleSize = null;
      this.selectedBox = null;
      this.selectedStyles = [];
      this.isEditing = false;
      this.hasEdited = false;
      this.showEditGrid = false;
      this.isAddingToCart = false;
      this.cartSuccess = false;
      this.cartError = null;
      window.__BYOB_ADDING_TO_CART__ = false;
    },

    editBox() {
      if (!this.capacity) return;
      this.phase = 'build';
      this.isEditing = true;
      this.hasEdited = false;
      this.showEditGrid = true;
      this.cartSuccess = false;
      this.cartError = null;
    },

    /* -----------------------------
       UTIL
    ----------------------------- */
        money(cents) {
      const value = Number(cents) || 0;
      return new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD'
      }).format(value / 100);
    }
      }))
  }

  if (window.Alpine) {
    register();
  }

  document.addEventListener('alpine:init', register);

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(register, 0);
  });
})();